import { useQuery } from 'react-query';
import API from '../api/phx';

const fetchCountries = async () => {
  const res = await API.get(`/countries`);
  return res.data;
};

export const useCountries = () => {
  return useQuery(['countries'], fetchCountries);
};


export default useCountries;